<template>
  <div>
    <div v-if="source === 'DISPLAY'">
      <icon-action-button 
        :routerPath="'/devices/ssedisplays'" 
        :queryObject="{ displayId: this.sourceId }" 
        :uiConfigBool="showDisplayInDisplayView"
        :iconNameDefault="'tv'"
        :iconNameOnHover="'tv-fill'"
        :tooltipText="'system_event.action_button.display_view_tooltip'"
        :sourceId="this.sourceId"
        >
      </icon-action-button>

      <icon-action-button 
        :routerPath="'/map/mapview'" 
        :queryObject="{ displayId: this.sourceId }" 
        :uiConfigBool="showDisplayOnMap"
        :iconNameDefault="'geo-alt'"
        :iconNameOnHover="'geo-alt-fill'"
        :tooltipText="'system_event.action_button.map_display_tooltip'"
        :sourceId="this.sourceId"
        >
      </icon-action-button>
    </div>

    <div v-else-if="source === 'VEHICLE'">
      <!-- TODO only redirection to usermessages view is working -->
      <icon-action-button 
        :routerPath="'/dispatching/usermessages'" 
        :queryObject="{ vehicleLabel: this.sourceId }" 
        :uiConfigBool="showSendMessageToVehicle"
        :iconNameDefault="'chat-left-text'"
        :iconNameOnHover="'chat-left-text-fill'"
        :tooltipText="'system_event.action_button.message_tooltip'"
        :sourceId="this.sourceId"
        >
      </icon-action-button>

      <icon-action-button 
        :routerPath="'/map/mapview'" 
        :queryObject="{ vehicleLabel: this.sourceId }" 
        :uiConfigBool="showVehicleOnMap"
        :iconNameDefault="'geo-alt'"
        :iconNameOnHover="'geo-alt-fill'"
        :tooltipText="'system_event.action_button.map_vehicle_tooltip'"
        :sourceId="this.sourceId"
        >
      </icon-action-button>
    </div>
  </div>
</template>

<script>
import IconActionButton from '@/components/UIComponents/IconActionButton.vue'

export default {
  name: 'ActionButtons',
  components: { IconActionButton },
  props: {
    source: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    sourceId: {
      type: String,
      required: true,
    },
    sizeClass: {
      type: String,
      default: 'h5'
    },
    showVehicleOnMap: {
      type: Boolean,
      default: false
    },
    showSendMessageToVehicle: {
      type: Boolean,
      default: false
    },
    showDisplayOnMap: {
      type: Boolean,
      default: false
    },
    showDisplayInDisplayView: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
  button {
    max-height: 45px;
    margin-right: 5px !important;
    padding: 7px !important;
  }
</style>